<template>
  <div class="app-container">
    <el-form :model="search" :inline="true" label-position="right" ref="search">
      <el-form-item label="门店编码" prop="id">
        <el-input v-model="search.id" placeholder="请输入完整门店编码" clearable></el-input>
      </el-form-item>
      <el-form-item label="门店名称" prop="storeName">
        <el-input v-model="search.storeName" placeholder="请输入门店名称（模糊）" clearable></el-input>
      </el-form-item>
      <el-form-item label="所在省份" prop="provinceCode">
        <el-select v-model="search.provinceCode" placeholder="请选择" clearable style="width: 100%" @change="provinceChange">
          <el-option v-for="item in provinceList" :key="item.provinceCode" :label="item.provinceName" :value="item.provinceCode"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所在城市" prop="cityCode">
        <el-select v-model="search.cityCode" placeholder="请选择" clearable style="width: 100%" :disabled="!search.provinceCode">
          <el-option v-for="item in cityList" :key="item.cityCode" :label="item.cityName" :value="item.cityCode"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="联系电话" prop="contactMobile">
        <el-input v-model="search.contactMobile" placeholder="请输入完整手机号" clearable></el-input>
      </el-form-item>
    </el-form>
    <div class="row-bg">
        <el-button type="primary" size="medium" @click="goAdd('add')">新增</el-button>
        <el-button type="primary" size="medium" @click="openImportDialog">导入</el-button>
        <el-button type="primary" size="medium" @click="exportExcel">导出</el-button>
      <div class="right-buttons">
        <el-button type="primary" size="medium" @click="handleSearch">查询</el-button>
        <el-button size="medium" @click="resetForm">重置</el-button>
      </div>
    </div>
    <el-table ref="checktableData" :data="list" v-loading="listLoading" :reserve-selection="true" center height="60vh">
      <el-table-column label="序号" type="index" min-width="60" align="center"></el-table-column>
      <el-table-column label="操作" fixed="left" min-width="200" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="toggle(scope.row)">
            {{ scope.row.status === 0 ? '禁用' : '启用' }}
          </el-button>
          <el-button type="text" @click="goAdd('edit', scope.row)">编辑</el-button>
          <el-button type="text" class="danger-btn" @click="delRow(scope.row)">删除</el-button>
        </template>
      </el-table-column>
      <el-table-column label="门店编码" prop="storeCode" min-width="180">
        <template slot-scope="scope">{{ scope.row.storeCode || scope.row.id }}</template>
      </el-table-column>
      <el-table-column label="门店名称" prop="storeName" min-width="180"></el-table-column>
      <el-table-column label="所在省份" prop="provinceName" min-width="120"></el-table-column>
      <el-table-column label="所在城市" prop="cityName" min-width="120"></el-table-column>
      <el-table-column label="联系电话" prop="contactMobile" min-width="140"></el-table-column>
      <el-table-column label="联系人" prop="contactName" min-width="120"></el-table-column>
      <el-table-column label="门店状态" prop="status" min-width="100">
        <template slot-scope="scope">
          {{ scope.row.status === 0 ? '正常' : '停用' }}
        </template>
      </el-table-column>
      
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="search.page"
        :page-size="search.rows"
        :page-sizes="[10, 20]"
        :total="total"
      >
      </el-pagination>
    </div>

    <storeDialog ref="storeDialogRef" @opera-success="getList"></storeDialog>

    <el-dialog title="门店导入" :visible.sync="importDialogVisible" width="400px" top="32vh" center>
      <div>
        <el-row type="flex" justify="center" class="row-bg">
          <el-col :span="8" class="font-blod">下载excel模版</el-col>
          <el-col :span="8">
            <el-button type="primary" @click="downloadImportTemplate">
              <div class="btnclass">
                <img src="@/assets/download.png" alt="" />
                <span>excel模版下载</span>
              </div>
            </el-button>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center" class="row-bg">
          <el-col :span="8" class="font-blod">导入excel</el-col>
          <el-col :span="8">
            <file-upload
              ref="importFileRef"
              @addUpload="importFileAdd"
              @removeUpload="removeImportFile"
              :title="'+导入excel文件'"
              :limit="1"
              v-if="showImportUpload"
            />
          </el-col>
        </el-row>
      </div>
      <div slot="footer" class="tableBtn">
        <div @click="importDialogVisible = false">取 消</div>
        <div @click="submitImport()">确认导入</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import fileUpload from '@/components/Upload/fileUpload'
import storeDialog from './components/storeDialog'
import { findAllProvince, findAllCity, getStoreList, deleteStore, updateStoreStatus, importStore } from '@/api/thirdPartyTradeIn'

export default {
  name: 'storeManagement',
  components: {
    fileUpload,
    storeDialog
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: false,
      provinceList: [],
      cityList: [],
      selectedRows: [],
      importDialogVisible: false,
      showImportUpload: true,
      importUpLoadData: {},
      search: {
        id: null,
        
        storeName: null,
        provinceCode: null,
        cityCode: null,
        contactMobile: null,
        page: 1,
        rows: 10
      }
    }
  },
  watch: {
    importDialogVisible(val) {
      if (!val) {
        setTimeout(() => {
          if (!this.global.handleEmptyData(this.importUpLoadData)) {
            this.$refs.importFileRef && this.$refs.importFileRef.$refs.upload.clearFiles()
          }
          this.importUpLoadData = {}
          this.showImportUpload = true
        }, 100)
      }
    }
  },
  mounted() {
    this.getProvinceList()
    this.getList()
  },
  methods: {
    // 获取省份列表
    async getProvinceList() {
      let { data, statusCode } = await findAllProvince()
      if (statusCode == 200) {
        this.provinceList = data || []
      }
    },
    // 获取城市列表
    async getCityList(provinceCode) {
      this.cityList = []
      if (!provinceCode) return
      let { data, statusCode } = await findAllCity(provinceCode)
      if (statusCode == 200) {
        this.cityList = data || []
      }
    },
    provinceChange(val) {
      this.search.cityCode = null
      this.getCityList(val)
    },
    // 查询
    handleSearch() {
      this.search.page = 1
      this.getList()
    },
    async getList() {
      this.listLoading = true
      let { data, statusCode } = await getStoreList(this.search)
      if (statusCode == 200) {
        this.list = (data && data.records) || []
        this.total = (data && data.total) || 0
      } else {
        this.list = []
      }
      this.listLoading = false
    },
    resetForm() {
      this.search = this.$options.data().search
      this.cityList = []
      this.getList()
    },
    handleSizeChange(val) {
      this.search.page = 1
      this.search.rows = val
      this.getList()
    },
    handleCurrentChange() {
      this.getList()
    },
    // 新增/编辑
    goAdd(type, rowData) {
      this.$refs.storeDialogRef.openDialog(type, rowData)
    },
    // 禁用/启用（0-正常 1-停用）
    toggle(row) {
      const toStatus = row.status === 0 ? 1 : 0
      this.$confirm(
        row.status === 0 ? '禁用后该门店将无法登录系统、无法使用任何业务功能，已登录账号立即失效；是否确认禁用？' : '是否确认启用该门店？',
        row.status === 0 ? '禁用确认' : '启用确认',
        {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.confirmToggle(row, toStatus)
        })
        .catch(() => {})
    },
    async confirmToggle(row) {
      if (!row.id) {
        this.$message.warning('数据异常，无法操作')
        return
      }
      // 该接口为切换状态（后端根据当前状态翻转），仅传门店id
      let { statusCode } = await updateStoreStatus(row.id)
      if (statusCode == 200) {
        this.$message.success(row.status === 0 ? '禁用成功' : '启用成功')
        this.getList()
      }
    },
    // 删除单条
    delRow(row) {
      if (!row.id) {
        this.$message.warning('数据异常，无法删除')
        return
      }
      this.$confirm('确认删除该门店吗？删除后数据不可恢复。', '删除确认', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.doDelete([row.id])
        })
        .catch(() => {})
    },
    // 批量删除
    delAll() {
      this.selectedRows = this.$refs.checktableData.selection || []
      if (!this.selectedRows.length) {
        this.$message.warning('请先勾选要删除的门店数据')
        return
      }
      this.$confirm(`确认删除选中的 ${this.selectedRows.length} 条门店数据吗？`, '删除确认', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.doDelete(this.selectedRows.map(item => item.id))
        })
        .catch(() => {})
    },
    // 删除请求
    async doDelete(ids) {
      let { statusCode, message } = await deleteStore(ids)
      if (statusCode == 200) {
        this.$message.success('删除成功')
        this.getList()
      } else {
        // 需求：有旧机明细时提示"已登记旧机，无法删除"
        this.$message.error(message || '删除失败')
      }
    },
    // 打开导入弹窗
    openImportDialog() {
      this.importDialogVisible = true
    },
    // 选择导入文件
    importFileAdd(item) {
      this.importUpLoadData = item
    },
    // 移除导入文件
    removeImportFile() {
      this.showImportUpload = true
      this.importUpLoadData = {}
    },
    // 确认导入
    submitImport() {
      if (this.global.handleEmptyData(this.importUpLoadData)) {
        this.$message.error('请上传文件')
        return
      }
      let formData = new FormData()
      formData.append('file', this.importUpLoadData.file)
      importStore(formData).then(res => {
        if (res.statusCode !== 200) {
          return this.$message.error(res.message || '导入失败')
        }
        if (res.data != null && res.data != "") {
          this.$message.error('文件有误, 请查看错误报告')
          this.getErrorReport(res.data)
        } else {
          this.$message.success('导入成功')
          this.importDialogVisible = false
          this.getList()
        }
      })
    },
    // 导入模板下载
    downloadImportTemplate() {
      this.global.exportExcel('/autoapp-default-server-recovery/api/file/downLoadTemplate', { templateName: 'ThirdPartyStoreExcel' }, '门店导入模板').catch(res => {
        let blob = new Blob([res.response.data], { type: 'application/json' })
        new Response(blob).json().then(r => this.$message.error(r.message))
      })
    },
    
    // 下载错误报告
    getErrorReport(downLoadId) {
      const url = `/autoapp-default-server-recovery/api/file/downLoadFailById`
      this.global.exportExcel(url, { downId: downLoadId }, '错误文件').catch(res => {
        let blob = new Blob([res.response.data], { type: 'application/json' })
        new Response(blob).json().then(r => this.$message.error(r.message))
      })
    },
    // 导出
    exportExcel() {
      let url = '/autoapp-default-server-recovery/api/third-party/store/exportPageCondition'
      this.HttpService.post(url, this.search).then(res => {
        if (res.statusCode == 200) {
          this.$message.success('正在导出, 稍后请到下载中心查看')
        } else {
          this.$message.warning(res.message)
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.row-bg {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  .batch-storage-button {
    margin-left: 10px;
    margin-right: 10px;
  }
  .right-buttons {
    margin-left: auto;
    display: flex;
    align-items: center;
  }
  .danger-btn {
    color: #f56c6c;
  }
}
.font-blod {
  font-weight: bold;
}
.btnclass {
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 20px;
    height: 20px;
    margin-right: 12px;
  }
}
.tableBtn {
  display: flex;
  justify-content: flex-end;
  div {
    // padding: 6px 16px;
    cursor: pointer;
    // border-radius: 4px;
  }
  div:last-child {
    background: #29b26b;
    color: #fff;
    margin-left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/thirdPartyTradeIn/storeManagement/list.vue